import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventosDto } from '../dto/expediente/evento.dto';
import { environment } from '../../environments/environment';
import { Constants } from '../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class EventoService {
  private apiUrl = `${environment.apiUrl}/evento`;

  constructor(private http: HttpClient) {}

  obtenerEventosPendientes(): Observable<EventosDto> {
    // Llama al endpoint para obtener los eventos pendientes
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN);    
    const headers =
    { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    }
    return this.http.get<EventosDto>(`${this.apiUrl}/pendientes` , { headers });
  }
}
